import { AvatarProps } from '@mui/material';

import Avatar from 'modules/IMC/MessageCenter/components/MessageCenterChat/common/SenderHeader/Avatar';
import { useMember } from 'modules/common/queries/member';

export default function MemberAvatar({ ...props }: AvatarProps) {
    const { data: member } = useMember();
    const nameInitial = member?.businessname[0] ?? '';

    return <Avatar name={nameInitial} color="primary" {...props} />;
}
